import { createElement, lazy, Suspense, useState } from 'react'

/**
 * Un plugin reactive-json chargé À LA DEMANDE.
 *
 * `builderPlugins` est le registre de TOUS les blocs : importé tel quel, il
 * embarque dans chaque paquet qui monte un bloc — l'éditeur comme le runtime
 * d'îlots des pages publiques — chart.js, react-grid-layout, l'éditeur riche…
 * même pour une page qui n'en rend aucun. Enveloppé ici, le composant garde son
 * nom dans le registre (aucun YAML ne change) et son code part dans un fichier
 * séparé, téléchargé au premier rendu qui le demande.
 *
 * Le rendu attend le code derrière un `Suspense` sans repli visible : sur une
 * page générée, le HTML statique reste à l'écran pendant ce temps
 * (`holdSsgPaint`).
 *
 * Code DÉJÀ chargé → rendu direct, sans `Suspense`. Ce n'est pas qu'une
 * optimisation : React retient l'affichage d'un contenu suspendu ~300 ms après
 * son repli, et le générateur statique, qui sérialise après 200 ms de silence,
 * figeait le bloc VIDE (carrousel absent du HTML). Le choix est fait UNE fois
 * par instance : basculer d'un chemin à l'autre au rendu suivant remonterait le
 * composant et lui ferait perdre son état.
 *
 * @param {() => Promise<Function>} load  rend le composant (pas le module)
 * @param {string} name  pour les DevTools
 */
export function lazyPlugin(load, name) {
  let loaded = null
  const ensure = () => load().then((component) => { loaded = component; return component })
  loaders.push(ensure)
  const Lazy = lazy(() => ensure().then((component) => ({ default: component })))
  const Plugin = (props) => {
    const [Direct] = useState(() => loaded)
    return Direct
      ? createElement(Direct, props)
      : createElement(Suspense, { fallback: null }, createElement(Lazy, props))
  }
  Plugin.displayName = `Lazy(${name})`
  return Plugin
}

const loaders = []

/**
 * Charge d'avance tous les plugins différés. Le générateur statique l'attend
 * avant de rendre : il juge la fin du rendu au silence RÉSEAU, qu'un import
 * différé ne trouble pas.
 */
export const preloadLazyPlugins = () => Promise.all(loaders.map((load) => load()))
